import { z } from 'zod';
import { contractPriceCalculationSchema } from './contract-price-calculation.schema';

export const registrationValuesSchema = z.object({
  electricity: z.boolean(),
  gas: z.boolean(),
  smart_meter: z.boolean(),
  residential: z.boolean().nullable(),
  electricity_price_period: z.string().nullable(),
  electricity_usage_normal: z.number().nullable(),
  electricity_usage_low: z.number().nullable(),
  electricity_usage_single: z.number().nullable(),
  electricity_generation_single: z.number().nullable(),
  electricity_generation_normal: z.number().nullable(),
  electricity_generation_low: z.number().nullable(),
  electricity_ean: z.string().nullable(),
  electricity_general_monthly_incl_vat_excl_pricecap: z.number().nullable(),
  gas_price_period: z.string().nullable(),
  gas_usage: z.number().nullable(),
  gas_ean: z.string().nullable(),
  gas_general_monthly_incl_vat_excl_pricecap: z.number().nullable(),
});

export const calculationSchema = z.object({
  product: z.string().optional(),
  registration_values: registrationValuesSchema.nullable().optional(),
  contract_price_calculation: contractPriceCalculationSchema
    .nullable()
    .optional(),
});

export type ICalculationState = z.infer<typeof calculationSchema>;
export type IRegistrationValues = z.infer<typeof registrationValuesSchema>;
